import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createNewLabel,
  deleteLabel,
  getLabelsList,
  removeLabelfromLabelsList,
  setConversationAttributes,
  updateConversationAttributesLocaly
} from '../../../redux/slices/communication';
import { useClickAway } from 'react-use';
import { getColor } from './colors';
import { useTranslate } from '@tolgee/react';
import { COMMUNICATION_ENABLE_LABELS } from '../constants';
import FeaturesToolTip from '../../featuresToolTip';
import { Button, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';

export function InputTags() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLabelsList());
  }, []);
  const inputRef = useRef(null);
  const [addedTagsCount, setAddedTagsCount] = useState(0);
  const {
    data: { labelsList, activeConversation }
  } = useSelector((state) => state.communication);
  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  console.log(activeConversation);
  useEffect(() => {
    setAllTags(labelsList);
  }, [labelsList]);
  const [filtredTags, setFiltredTags] = useState(allTags);
  useEffect(() => {
    const _filtredTags = allTags.filter(
      (item) =>
        !tags.find((tag) => tag.text.toLowerCase() === item.text.toLowerCase())
    );
    setFiltredTags(_filtredTags);
  }, [tags, allTags]);
  useEffect(() => {
    if (activeConversation) {
      setTags(
        activeConversation?.labels?.slice()?.sort((a, b) => {
          if (a.text < b.text) return -1;
          if (a.text > b.text) return 1;
          return 0;
        }) || []
      );
      setSearchState(false);
      setNewTagName('');
      if (inputRef?.current) inputRef.current.value = '';
      const labelNames = activeConversation?.labels?.map((item) => item.text);
      setAllTags(labelsList.filter((item) => !labelNames.includes(item.text)));
      setShowAddLabel(true);
    }
  }, [activeConversation]);

  const onDeleteLabelGlobal = (deletedLabel) => {
    dispatch(
      deleteLabel(deletedLabel.uuid, () => {
        dispatch(getLabelsList());
        toast.success(t('communication.toast.label_has_been_deleted'), {
          position: 'top-right'
        });
      })
    );
    dispatch(removeLabelfromLabelsList(deletedLabel.uuid));
    console.log('Ask for conversation, delete label', deletedLabel);
  };

  const onAddLabel = (label) => {
    const tgs = [...tags, label];
    // remove duplicates by uuid and keep entries with null uuid
    const uniqueTags = tgs.filter(
      (item, index, self) =>
        index ===
        self.findIndex((t) => t.text.toLowerCase() === item.text.toLowerCase())
    );

    setTags(
      uniqueTags.slice()?.sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      })
    );
    setSearchState(false);
    setNewTagName('');
    setFiltredTags(
      allTags.filter(
        (item) =>
          !uniqueTags.find(
            (tag) => tag.text.toLowerCase() === item.text.toLowerCase()
          )
      )
    );
    if (inputRef?.current) inputRef.current.value = '';

    // dispatch update labels list
    dispatch(
      setConversationAttributes(
        activeConversation.uuid,
        {
          labels: uniqueTags
        },
        () => dispatch(getLabelsList())
      )
    );
  };
  const [newTagName, setNewTagName] = useState('');
  const onSearchChange = (e) => {
    if (!userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS]) return;
    // search in all labels state
    const textTags = tags.map((item) => item.text);
    const filtredtags = allTags
      .filter((tag) => !textTags.includes(tag.text))
      .filter(
        (item) =>
          item.text.toLowerCase().includes(e.target.value.toLowerCase()) ||
          !e.target.value
      );
    setFiltredTags(filtredtags);
    // setAllTags(filtredtags);
    setNewTagName(e.target.value);
  };
  const onDeleteLabel = (deletedLabel) => {
    const tgs = tags.filter(
      (item) => item.text.toLowerCase() !== deletedLabel.text.toLowerCase()
    );
    // remove duplicates by uuid and keep entries with null uuid
    setTags(
      tgs.slice()?.sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      })
    );
    // dispatch update labels list
    dispatch(
      setConversationAttributes(activeConversation.uuid, {
        labels: tgs
      })
    );
  };
  const [searchState, setSearchState] = useState(false);
  const dropdownRef = useRef(null);
  useClickAway(dropdownRef, () => {
    setSearchState(false);
  });
  const handleKeyDown = (e) => {
    if (!userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS]) return;
    if (e.key === 'Enter') {
      // random uuid
      // create a new label
      if (!newTagName) return;

      if (
        tags.find(
          (item) => item.text.toLowerCase() === newTagName.toLowerCase()
        )
      ) {
        e.target.value = '';
        e.target.blur();
        setSearchState(false);
        return;
      }
      const newLabel = {
        uuid: addedTagsCount,
        color: getColor(allTags.length + addedTagsCount, 'opacity'),
        text: newTagName
      };
      dispatch(
        createNewLabel({ text: newTagName, color: newLabel.color }, (label) => {
          dispatch(getLabelsList());
          onAddLabel(label);
        })
      );

      setAllTags([
        ...allTags,
        {
          ...newLabel,
          uuid: addedTagsCount,
          color: getColor(allTags.length + addedTagsCount, 'opacity')
        }
      ]);
      setAddedTagsCount(addedTagsCount + 1);
      // onAddLabel(newLabel);
      setNewTagName('');
      // clean the input fiekd
      e.target.value = '';
      // deselect the input field
      e.target.blur();
      setSearchState(false);
    }
  };
  useEffect(() => {
    if (activeConversation?.uuid)
      dispatch(
        updateConversationAttributesLocaly(activeConversation.uuid, {
          labels: tags.slice().sort((a, b) => a.text.localeCompare(b.text))
        })
      );
  }, [tags]);

  const { t } = useTranslate();
  const { userData } = useSelector((state) => state.userDetails);
  const [show, setShow] = useState(false);
  const [labelToDelete, setLabelToDelete] = useState(null);
  const handleClose = () => setShow(false);
  const handleDelete = () => {
    if (labelToDelete) {
      onDeleteLabelGlobal(labelToDelete);
      setLabelToDelete(null);
    }
    setShow(false);
  };
  const [showAddLabel, setShowAddLabel] = useState(true);
  return (
    <div className="m-3 w-100">
      <Modal show={show} onHide={handleClose} className="border-0">
        <Modal.Header closeButton>
          <Modal.Title>
            {t('communication.general_info.delete_label_comfirmation')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('communication.general_info.delete_label_comfirmation_text')}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="secondary" size="sm" onClick={() => setShow(false)}>
            {t('communication.general_info.cancel')}
          </Button>
          <Button variant="danger" size="sm" onClick={handleDelete}>
            {t('communication.general_info.delete')}
          </Button>
        </Modal.Footer>
      </Modal>
      <b className="text-muted m-0 mb-2 p-0 fs-6 fw-bold">
        {t('communication.general_info.select_or_create_tag_title')}
      </b>
      {tags?.length > 0 && (
        <div className="d-flex flex-wrap overflow-none p-3">
          {tags
            ?.sort((a, b) => a.text.localeCompare(b.text))
            ?.map((item, i) => {
              return (
                <div
                  className={`d-flex fw-bold align-items-center mx-1 my-1 fs-7  badge badge-sm cursor-pointer text-break opacity-75`}
                  style={{
                    backgroundColor: `${item.color.replace('opacity', '0.125')}`
                  }}
                  key={i}
                >
                  <span
                    style={{ color: item.color.replace('opacity', '1') }}
                    className="text-truncate"
                  >
                    {item.text}
                  </span>

                  <i
                    className="fa-duotone fa-times mx-1"
                    style={{ color: item.color.replace('opacity', '1') }}
                    onClick={() => onDeleteLabel(item)}
                  ></i>
                </div>
              );
            })}
        </div>
      )}

      {userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS] ? (
        <>
          {showAddLabel && tags.length === 0 && (
            <div className="w-100 mt-2">
              <span
                className="align-items-center badge badge-sm cursor-pointer badge-light text-dark fs-7 p-2"
                onClick={() => {
                  setShowAddLabel(false);
                  setTimeout(() => inputRef.current.focus(), 0);
                }}
              >
                <i
                  className="fa-duotone fa-plus mr-2 text-dark"
                  style={{ marginRight: 5 }}
                ></i>

                {t('communication.general_info.add_label')}
              </span>
            </div>
          )}

          <input
            ref={inputRef}
            placeholder={t('communication.general_info.select_or_create_tag')}
            className={`form-control form-control-sm border-0 mt-1 ${
              showAddLabel && tags.length == 0 ? 'd-none' : ''
            }`}
            onFocus={() => {
              if (
                userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS]
              ) {
                setSearchState(true);
              }
            }}
            // onBlur={() => setSearchState(false)}
            onChange={onSearchChange}
            onKeyDown={handleKeyDown}
          />
        </>
      ) : (
        <FeaturesToolTip
          featureIsActive={
            userData?.feature_list_for_user[COMMUNICATION_ENABLE_LABELS]
          }
          feature={COMMUNICATION_ENABLE_LABELS}
          InnerComponent={() => (
            <p className="fw-bold text-muted fs-7 mx-2 my-2">
              {t('communication.general_info.select_or_create_tag')}
            </p>
          )}
        />
      )}
      {searchState && filtredTags.length > 0 && (
        // here add condition onClick away
        <div
          className="card p-3 m-1 shadow position-absolute"
          style={{
            zIndex: 9,
            maxHeight: 200,
            overflowY: 'auto',
            maxWidth: '100%',
            width: '90%'
          }}
          ref={dropdownRef}
        >
          {filtredTags
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((item) => {
              return (
                <div
                  className="w-100 d-flex align-items-center bg-hover-secondary rounded user-select-none cursor-pointer"
                  key={item.uuid}
                  onClick={() => onAddLabel(item)}
                >
                  <div
                    className={
                      'd-flex justify-content-between align-items-center w-100'
                    }
                  >
                    <div>
                      <div
                        className={`d-flex fw-bold align-items-center mx-1 my-1 px-2 rounded py-1 cursor-pointer`}
                      >
                        <i
                          className="fa-solid fa-circle mx-1"
                          style={{
                            color: item.color.replace('opacity', '1')
                          }}
                        ></i>
                        <span>{item.text}</span>
                      </div>
                    </div>
                    <div
                      className={'px-5 z-6'}
                      style={{ zIndex: 999 }}
                      onClick={(e) => {
                        e.stopPropagation(); // This stops the click event from propagating to the parent div
                        setLabelToDelete(item);
                        setShow(true);
                      }}
                    >
                      <span>
                        <i className={'fa-duotone fa-times'}></i>
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}
